<script setup lang="ts">
import { useToast } from "../stores/toast";
const toast = useToast();
</script>

<template>
  <Transition name="toast">
    <div v-if="toast.visible" class="toast">
      <span class="check">✓</span> {{ toast.message }}
    </div>
  </Transition>
</template>

<style scoped>
.toast {
  position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); z-index: 100;
  display: flex; align-items: center; gap: 8px; background: var(--ink); color: #fff;
  padding: 12px 18px; border-radius: 999px; font-weight: 600; font-size: 14px;
  box-shadow: 0 12px 30px -8px rgba(20, 20, 20, 0.5);
}
.check { color: #5fd6a6; font-weight: 800; }
.toast-enter-active, .toast-leave-active { transition: opacity 0.2s, transform 0.2s; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translate(-50%, 10px); }
</style>
